export default __webpack_public_path__ + "static/media/640_dummy2016-psychotherapie01-mobile-de.9f262add.png";